import { API } from 'utils/api/api'
import {
  GetClassificationDetailsParams,
  ClassificationDetails,
} from '@ketch-com/windlass/dist/dataSentry/v1/events/events'
import { formatRequestString } from 'utils/helpers/api/queryString'

export const fetchClassificationDetails = ({
  'classification-type': classificationType,
  'classification-code': classificationCode,
}: GetClassificationDetailsParams) => {
  return API.get<ClassificationDetails>(
    formatRequestString({
      entityUrl: '/api/v1/data-sentry/events/classification-details',
      params: {
        filters: {
          ...(classificationType
            ? {
                'classification-type': classificationType,
              }
            : {}),
          ...(classificationCode
            ? {
                'classification-code': classificationCode,
              }
            : {}),
        },
      },
    }),
  )
}
